import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '../../../core/shared/material.module';

@Component({
  selector: 'app-add-test-suite',
  standalone: true,
  imports: [FormsModule, CommonModule, MaterialModule],
  templateUrl: './add-test-suite.component.html',
  styleUrl: './add-test-suite.component.scss',
})
export class AddTestSuiteComponent {
  @Input() configs: any = {};
  /** Kept for backward compatibility with existing open() callers. */
  @Input() data: any = {};

  activeModal = inject(NgbActiveModal);

  testSuiteName = '';
  isActive = false;

  get canSubmit(): boolean {
    return !!this.testSuiteName?.trim();
  }

  /**
   * Closes the modal with the entered test suite name when valid.
   */
  submit(): void {
    const name = this.testSuiteName?.trim();
    if (!name) {
      return;
    }
    this.activeModal.close({ testSuite: name });
  }
}
